export default "__VITE_ASSET__BYeDsGgy__"